import { render, staticRenderFns } from "./AnnotationSubmission.vue?vue&type=template&id=93d40a98&scoped=true"
import script from "./AnnotationSubmission.vue?vue&type=script&lang=js"
export * from "./AnnotationSubmission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93d40a98",
  null
  
)

export default component.exports